// extracted by mini-css-extract-plugin
export var resizer = "_ec-0";